<template>
  <div class="search-bar edit-results">
    <div class="columns" style="justify-content: space-between">
      <h3 style="margin-right: 2rem">אשמח למצוא שיעור</h3>
      <div class="has-text-left top-controls">
        <a
          href="#"
          class="advanced-search-control"
          @click.prevent="$emit('show-textsearch')"
          ><i class="mdi mdi-magnify"></i> חיפוש חופשי</a
        >
        <a
          href="#"
          class="advanced-search-control"
          @click.prevent="$emit('close-edit-results')"
          ><i class="mdi mdi-close"></i> חיפוש מתקדם</a
        >
      </div>
    </div>
    <div class="video-filter-container">
      <div class="columns is-multiline basic-search">
        <div class="column is-3-desktop">
          <dropdown-multi
            :item="metaStyleOptions"
            :show="buttons.metaStyles"
            v-on:show-options="openOptions('metaStyles')"
            v-on:close-options="closeOptions()"
            v-on:option-selected="updateSelection($event, 'metaStyles')"
          ></dropdown-multi>
        </div>
        <div class="column is-3-desktop">
          <dropdown-multi
            :item="styleOptions"
            :show="buttons.styles"
            v-on:show-options="openOptions('styles')"
            v-on:close-options="closeOptions()"
            v-on:option-selected="updateSelection($event, 'styles')"
          ></dropdown-multi>
        </div>
        <div class="column is-3-desktop">
          <dropdown-multi
            :item="levelOptions"
            :show="buttons.levels"
            :cols="1"
            v-on:show-options="openOptions('levels')"
            v-on:close-options="closeOptions()"
            v-on:option-selected="updateSelection($event, 'levels')"
          ></dropdown-multi>
        </div>
        <div class="column is-3-desktop">
          <dropdown-multi
            :item="{
              title: 'אורך',
              includes: $store.state.initialData.durations,
              info: 'testing',
              selected: selected.durations,
            }"
            :show="buttons.durations"
            v-on:show-options="openOptions('durations')"
            v-on:close-options="closeOptions()"
            v-on:option-selected="updateSelection($event, 'durations')"
          ></dropdown-multi>
        </div>
      </div>

      <div>
        <hr />
        <h4>מאפייני שיעור</h4>
        <div class="columns is-multiline">
          <div class="column is-6-desktop">
            <dropdown-single
              :item="tempoOptions"
              :show="buttons.tempo"
              v-on:show-options="openOptions('tempo')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'tempo')"
            ></dropdown-single>
          </div>
          <div class="column is-6-desktop">
            <dropdown-multi
              :item="teacherOptions"
              :show="buttons.teachers"
              v-on:show-options="openOptions('teachers')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'teachers')"
            ></dropdown-multi>
          </div>
        </div>
        <hr />
        <h4>במה להתמקד?</h4>
        <div class="columns is-multiline">
          <div class="column is-4-desktop">
            <dropdown-multi
              :item="focusOptions"
              :show="buttons.focus"
              v-on:show-options="openOptions('focus')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'focus')"
            ></dropdown-multi>
          </div>
          <div class="column is-4-desktop">
            <dropdown-multi
              :item="bodyPartOptions"
              :show="buttons.bodyPart"
              v-on:show-options="openOptions('bodyPart')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'bodyPart')"
            ></dropdown-multi>
          </div>
          <div class="column is-4-desktop">
            <dropdown-multi
              :item="equipmentOptions"
              :show="buttons.equipment"
              v-on:show-options="openOptions('equipment')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'equipment')"
            ></dropdown-multi>
          </div>
        </div>
        <hr />
        <div class="has-text-centered">
          <a href="#" class="yoga-btn" @click.prevent="getResults">חיפוש</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownMulti from "@/components/newSearch/searchDropDownMulti.vue";
import DropdownSingle from "@/components/newSearch/searchDropdownSingle.vue";

export default {
  data() {
    return {
      selected: {
        metaStyles: [],
        styles: [],
        levels: [],
        durations: [],
        tempo: [],
        teachers: [],
        focus: [],
        bodyPart: [],
        equipment: [],
      },
      buttons: {
        metaStyles: false,
        styles: false,
        levels: false,
        durations: false,
        tempo: false,
        teachers: false,
        focus: false,
        bodyPart: false,
        equipment: false,
      },
    };
  },
  components: {
    DropdownMulti,
    DropdownSingle,
  },
  computed: {
    metaStyleOptions() {
      const metaStyles = this.$store.state.initialData.styles.map(item => {
        let tags = [];
        this.$store.state.initialData.currents.forEach(c => {
          if (item.includes.includes(c.resource.id)) {
            tags.push(c.id);
          }
        });
        return { id: item.MIGX_id, label: item.label, includes: tags };
      });
      return {
        title: "סגנון",
        includes: metaStyles,
        selected: this.selected.metaStyles,
      };
    },
    styleOptions() {
      const metaStyles = this.$store.state.initialData.styles;
      let styles = this.$store.state.initialData.currents;
      if (this.selected.metaStyles.length > 0) {
        const selected = this.selected.metaStyles.map(item => {
          return item.id;
        });
        let included = [];
        metaStyles.forEach(meta => {
          if (selected.includes(meta.MIGX_id)) {
            if (included.length > 0) {
              included = [...included, ...meta.includes];
            } else {
              included = meta.includes;
            }
          }
        });
        styles = styles.filter(style => included.includes(style.resource.id));
      }
      return {
        title: "זרם",
        includes: styles,
        selected: this.selected.styles,
      };
    },
    levelOptions() {
      const levels = this.$store.state.initialData.levels.map(item => {
        return { label: item.label, id: item.value, value: item.value };
      });
      return {
        title: "רמה",
        includes: levels,
        info: "testing",
        selected: this.selected.levels,
      };
    },
    tempoOptions() {
      const levels = this.$store.state.initialData.tempo.map(item => {
        return {
          label: item.label,
          id: item.MIGX_id,
          value: item.MIGX_id,
        };
      });
      return {
        title: "קצב השיעור",
        includes: levels,
        selected: this.selected.tempo,
      };
    },
    teacherOptions() {
      const teachers = this.$store.state.initialData.teachers;
      let list = [];
      if (this.selected.styles.length > 0) {
        // filter teachers
        list = teachers.filter(t => {
          let status = false;
          t.currents.forEach(s => {
            const selected = this.selected.styles.map(item => item.id);
            if (selected.includes(s.tag)) {
              status = true;
            }
          });
          return status;
        });
      } else {
        if (this.selected.metaStyles.length > 0) {
          const metaIncludes = this.selected.metaStyles.map(s => s.includes);
          let styles = [];
          metaIncludes.forEach(mi => {
            styles = [...styles, ...mi];
          });
          list = teachers.filter(t => {
            let status = false;
            t.currents.forEach(s => {
              if (styles.includes(s.tag)) {
                status = true;
              }
            });
            return status;
          });
        } else {
          list = teachers;
        }
      }
      list = list.map(teacher => {
        return { id: teacher.id, label: teacher.name };
      });
      return {
        title: "מורה",
        includes: list,
        selected: this.selected.teachers,
      };
    },
    focusOptions() {
      const list = this.$store.state.initialData.focusList.map(item => {
        return { label: item.label, id: item.MIGX_id };
      });
      return {
        title: "מטרת השיעור",
        includes: list,
        selected: this.selected.focus,
      };
    },
    bodyPartOptions() {
      const list = this.$store.state.initialData.bodyPart.map(item => {
        return { label: item.label, id: item.MIGX_id };
      });
      return {
        title: "איזור בגוף",
        includes: list,
        selected: this.selected.bodyPart,
      };
    },
    equipmentOptions() {
      const list = this.$store.state.initialData.equipment.map(item => {
        return { label: item.label, id: item.id };
      });
      return {
        title: "אביזר",
        includes: list,
        selected: this.selected.equipment,
      };
    },
  },
  methods: {
    openOptions(name) {
      let keys = Object.keys(this.buttons);
      let obj = {};
      keys.forEach(key => {
        if (key === name) {
          obj[key] = true;
        } else {
          obj[key] = false;
        }
        this.buttons = obj;
      });
      this.buttons[name] = true;
    },
    closeOptions() {
      this.buttons = {
        metaStyles: false,
        styles: false,
        levels: false,
        durations: false,
        tempo: false,
        teachers: false,
        focus: false,
        bodyPart: false,
        equipment: false,
      };
    },
    checkClose(e) {
      if (
        e.target.classList[0] !== "dropdown-btn" &&
        e.target.classList[0] !== "dropdown-option" &&
        e.target.classList[0] !== "mdi"
      ) {
        this.closeOptions();
      }
    },
    updateSelection(payload, target) {
      this.selected[target] = payload;
      this.$store.dispatch(`setSearchParams`, this.selected);
    },
    getResults(e) {
      let obj = {
        term: this.searchTerm,
        metaStyles: this.flattenQuery(this.selected.metaStyles),
        styles: this.falttenStylesQuery(this.selected.styles),
        levels: this.flattenQuery(this.selected.levels),
        durations: this.flattenQuery(this.selected.durations),
        tempo: this.flattenQuery(this.selected.tempo),
        teachers: this.flattenQuery(this.selected.teachers),
        focus: this.flattenQuery(this.selected.focus),
        bodyPart: this.flattenQuery(this.selected.bodyPart),
        equipment: this.flattenQuery(this.selected.equipment),
      };

      this.$store.dispatch(`getVideoResults`, obj);
      this.$store.dispatch(`setSearchParams`, this.selected);
      e.currentTarget.blur();
      this.$router.push("results");
    },
    flattenQuery(arr) {
      const ids = arr.map(item => item.id);
      return ids.join(",");
    },
    falttenStylesQuery(arr) {
      const ids = arr.map(item => item.resource.id);
      return ids.join(",");
    },
  },
  mounted() {
    if (Object.keys(this.$store.state.sort.selected).length > 0) {
      this.selected = this.$store.state.sort.selected;
    }
    this.searchTerm = this.$store.state.sort.term;
  },
  created() {
    window.addEventListener("click", this.checkClose);
  },
  destroyed() {
    window.removeEventListener("click", this.checkClose);
  },
};
</script>



